import { formValueSelector } from 'redux-form';
import { SINGLE_BOUND } from '../constants/formFieldNames';

const getSelected = (form, field) => (state) => formValueSelector(form)(state, `${field}`);

export const getSingleBound = (form) => (state) => getSelected(form, SINGLE_BOUND)(state);
